import { combineReducers } from 'redux';
import { BuildingTypes } from '../../action_types';
import { arrayToObject, removeItem, insertItem, updateObjectInArray } from '@app/utils/helpers';

function all(state = {}, action) {
  switch (action.type) {
    case BuildingTypes.GET_BUILDINGS_BY_ORG_SUCCESS:
      return { ...state, ...arrayToObject(action.data.results) };
    case BuildingTypes.GET_BUILDING_SUCCESS:
    case BuildingTypes.UPDATE_BUILDING_SUCCESS:
    case BuildingTypes.DEACTIVATE_BUILDING_SUCCESS:
    case BuildingTypes.ACTIVATE_BUILDING_SUCCESS:
      return {
        ...state,
        [action.data.id]: action.data,
      };
    default:
      return state;
  }
}

function ui(state = [], action) {
  switch (action.type) {
    case BuildingTypes.GET_BUILDINGS_BY_ORG_SUCCESS:
      return action.data.results;
    case BuildingTypes.UPDATE_BUILDING_SUCCESS:
    case BuildingTypes.DEACTIVATE_BUILDING_SUCCESS:
    case BuildingTypes.ACTIVATE_BUILDING_SUCCESS:
      return updateObjectInArray(state, action.data);
    default:
      return state;
  }
}

function meta(state = {}, action) {
  switch (action.type) {
    case BuildingTypes.GET_BUILDINGS_BY_ORG_SUCCESS:
      const { results, ...rest } = action.data;
      return { ...state, ...rest };
    default:
      return state;
  }
}

export default combineReducers({
  all,
  ui,
  meta,
});
